const BASE_IP = "https://cornerstoneinc.io/";

export const API_URL = BASE_IP + "api/";

export const SERVER_URL = BASE_IP;